export default __webpack_public_path__ + "static/media/screenshot1.34d44fa6.png";